import Collapsible from 'components/collapsible';
import List from 'components/list/list';
import React from 'react';
import { useIntl } from 'react-intl';
import _ from 'underscore';
import { SubFolder } from '../types/shared-folder.type';
import FolderRow from './folder-row';

const PAGE_NAME_ID = 'fileSharing';

type Props = {
  folders: SubFolder[];
  handleClick: (value: string) => void;
};
const FolderList: React.FC<Props> = ({ folders, handleClick }) => {
  const intl = useIntl();

  return (
    <Collapsible label={intl.formatMessage({ id: `${PAGE_NAME_ID}.subFolders` })} open={true}>
      <List
        dark
        options={[
          { id: 'name', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.folderName` }) },
          { id: 'actions', label: '' },
        ]}
        orderBy="name"
        isLoading={false}
        noResult={{
          show: !folders?.length,
          text: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.noSubFolders` }),
        }}>
        {_.chain(folders)
          .sortBy((f) => f.name.toLocaleLowerCase())
          .value()
          .map((folder) => (
            <FolderRow key={folder.id} folder={folder} handleClick={handleClick} />
          ))}
      </List>
    </Collapsible>
  );
};

export default React.memo(FolderList);
